/**
 * The page container: one edge for the whole site, capped at 1920px.
 *
 * Every section, page and piece of chrome uses it, and that is the point —
 * the nav, the hero, the fleet grid and the footer all stop at the same
 * line. Capping only the marketing page left the logo floating 280px inside
 * the fleet grid on a wide display, which read as a bug rather than a
 * choice.
 *
 * The cap and the gutters are Airbnb's, measured off airbnb.com rather than
 * guessed at: the shell stops at 1920px and the gutter steps 24 → 32 → 48px
 * at 1128px and 1440px, so a 2560px display shows a centred 1920px page with
 * 1824px of content. Those two step points are Airbnb's own breakpoints, not
 * Tailwind's, hence the arbitrary variants. It is a cap chosen for the *grid*
 * rather than for prose: at 1280px a 4-across fleet grid runs out of room and
 * drops to 3, wasting a third of a 1920px display. The headline is held back
 * separately — see the `max-w-*` on the `h1` in `Hero` — because a line of
 * type that runs 1920px is a line nobody finishes. Only the grid wants the
 * width.
 *
 * Only the *content* is capped. Section backgrounds — the CTA band, the
 * footer, the hero grid — stay full-bleed, because a band that stops short
 * of the viewport is not a band.
 *
 * Written as one string rather than composed at runtime: Tailwind reads
 * class names out of the source, so it has to see them spelled out.
 */
export const CONTAINER =
  'mx-auto w-full max-w-[1920px] px-6 min-[1128px]:px-8 min-[1440px]:px-12';
